// extracted by mini-css-extract-plugin
module.exports = {"bkw-A":"A_bkw-A__UtCAN"};